
import React from "react";
import Header from "./Header";
import BottomNavigation from "./BottomNavigation";

interface AppLayoutProps {
  children: React.ReactNode;
  title: string;
  showBack?: boolean;
  action?: React.ReactNode;
  hideNav?: boolean;
}

const AppLayout: React.FC<AppLayoutProps> = ({
  children,
  title,
  showBack,
  action,
  hideNav = false,
}) => {
  return (
    <div className="min-h-screen pb-16">
      <Header title={title} showBack={showBack} action={action} />
      <main className="mobile-container pt-4 pb-20">{children}</main>
      
      {/* Footer added to AppLayout */}
      <div className="py-4 text-center text-xs text-gray-500 dark:text-gray-400 mobile-container">
        Bilanga Mayele <span className="mx-1">•</span> Bilanga Solutions © 2025. Tous droits réservés.
      </div>
      
      {!hideNav && <BottomNavigation />}
    </div>
  );
};

export default AppLayout;
